<div [class]="getClass()">
  <ng-content></ng-content>
</div>
